import React from "react";
import { Row, Col, Card, Table } from "antd";
import { columns } from "utils/TablesData";
export default function Schedule() {
  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Schedule"
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}
